import Button from '../../components/common/button';
import {clearAllForgotPasswordAlerts} from "../../actions/session";
import {Link} from "react-router-dom";
import {useDispatch} from "react-redux";
import {route as FORGOT_PASSWORD_ROUTE} from '../forgotPassword';

const LoginForm = (props) => {
  const {
    title,
    subtitle,
    submitLabel,
    submitAction,
    children,
    showForgotPasswordLink,
    disabled
  } = props;

  const dispatch = useDispatch();

  const forgotPasswordLink = <Link to={FORGOT_PASSWORD_ROUTE} onClick={(e) => dispatch(clearAllForgotPasswordAlerts())}>Forgot Password</Link>

  return (
    <form className='login'>
      <h2 className='login-title'>{title.toUpperCase()}</h2>
      { subtitle && <span className='subtitle'>{subtitle}</span> }
      <div className='form-items'>
        { children }
      </div>
      <Button label={submitLabel} action={submitAction} disabled={disabled}/>
      <div className='login-form-links'>
        { showForgotPasswordLink && forgotPasswordLink }
      </div>
    </form>
  );
};

export default LoginForm;
